import { render, staticRenderFns } from "./productprice.vue?vue&type=template&id=cd1e7b54"
import script from "./productprice.vue?vue&type=script&lang=js"
export * from "./productprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports